import React from "react";

// Amazon wordmark logo (inline SVG, brand-accurate smile)
export function AmazonLogo({ className = "h-4 w-auto", dark = false }) {
  const fill = dark ? "#0A0A0A" : "#0A0A0A";
  return (
    <svg viewBox="0 0 100 30" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Amazon">
      <text x="0" y="20" fontFamily="Inter, Arial, sans-serif" fontWeight="700" fontSize="20" fill={fill}>amazon</text>
      <path d="M6 24 C 24 32, 60 32, 78 24" stroke="#FF9900" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M74 22 l6 2 -3 5" fill="#FF9900" />
    </svg>
  );
}

// Goodreads "g" logo
export function GoodreadsLogo({ className = "h-4 w-auto" }) {
  return (
    <svg viewBox="0 0 130 30" className={className} xmlns="http://www.w3.org/2000/svg" aria-label="Goodreads">
      <circle cx="14" cy="15" r="13" fill="#553B08" />
      <text x="8" y="21" fontFamily="Georgia, serif" fontWeight="700" fontSize="18" fill="#F4F1EA">g</text>
      <text x="32" y="20" fontFamily="Inter, Arial, sans-serif" fontWeight="600" fontSize="15" fill="#553B08">goodreads</text>
    </svg>
  );
}

export function Stars({ rating = 5, size = 16, className = "" }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5 stars`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full;
        const isHalf = i === full && half;
        return (
          <svg key={i} width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id={`half-${i}`}>
                <stop offset="50%" stopColor="#D4AF37" />
                <stop offset="50%" stopColor="#E5E7EB" />
              </linearGradient>
            </defs>
            <path
              d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 18.9 6.1 21l1.2-6.5L2.5 9.9l6.6-.9L12 2.5z"
              fill={filled ? "#D4AF37" : isHalf ? `url(#half-${i})` : "#E5E7EB"}
            />
          </svg>
        );
      })}
    </div>
  );
}
